import { render } from "./NotifyIconField.vue?vue&type=template&id=774be2ec"
import script from "./NotifyIconField.vue?vue&type=script&lang=js"
export * from "./NotifyIconField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__